import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=e0f81ef4"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0f81ef4')) {
      api.createRecord('e0f81ef4', component.options)
    } else {
      api.reload('e0f81ef4', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=e0f81ef4", function () {
      api.rerender('e0f81ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/spu/ordinary/edit.vue"
export default component.exports